/**
 * KPI Tracking's sidebar leaf, ported from v3's `DefaultLayout.vue:250–255`:
 *
 *   { name: 'KPI Tracking', url: 'KPITracking', control: 'Permission', id: ['kpi_realized_values'] }
 *
 * verbatim in the typed contribution model — the label becomes an i18n key and `url` becomes a
 * route target. The permission array is kept as an array: `useNavVisibility`'s `permission`
 * control accepts a key or an ANY-of list, and v3 wrote the list form here.
 *
 * The label key lives in the eager `shell.*` bundle rather than this feature's lazy bundle, so the
 * rail is never left rendering a raw key before the scorecards chunk has loaded.
 *
 * v3 nests this leaf under a `Workflows` group whose other two children — AI Workflow (module 14)
 * and Impact Analysis (module 13) — do not exist in v4 yet. The group itself is declared by the
 * shell (`registerShellNavigation`), permission-neutral, exactly like `Cockpit`: its leaves
 * own the gates and `buildNavNode` drops a group whose every child was pruned.
 */
export const scorecardNavItems = [
  {
    labelKey: 'shell.nav.kpiTracking',
    to: { name: 'KPITracking' },
    navKey: 'kpiTracking',
    // Literal-narrowed so app wiring verifies this inferred contribution against `NavItem`
    // without reversing the enforced app -> feature dependency direction for a type import.
    visibility: { control: 'permission' as const, id: ['kpi_realized_values'] },
  },
]
